export default __webpack_public_path__ + "static/media/q19_step2.115a75ed.png";